import { message } from "skin/event";
import { status } from "skin/event/status";

// Выкл (вкл) PUSH уведомления для склада(ов)
const tnk_allPush = (obj, ms, story, data, d, action) => {
	if (obj.type === "btn" && obj.action === "click") getBtn(data);
	if (obj.action === "setInput") {
		data.setValue("text", "Вы устанавливаете ограничение работы PUSH");
	}
	if (obj.action === "next") return check(data);
	return status.action;
};

export default tnk_allPush;

// Очищаем поля времени при нажатии на кнопку
function getBtn(data) {
	data.setValue("off", "");
	data.setValue("on", "");
	data.setValue("text", "Ограничения работы PUSH будут убраны");
	return status.action;
}

// Проверяем что бы даты периода были указаны корректно
function check(data) {
	const on = data.curData.values.fld.on;
	const off = data.curData.values.fld.off;
	if (on && !off) {
		message("Укажите с какого числа выключить оповещения", "Ошибка заполнения полей");
		return status.ignore;
	}
	if (!!off && !!on && off > on) {
		message("Дата начала не может быть больше даты окончания", "Ошибка заполнения полей");
		return status.ignore;
	}
	if (!!off && !!on && off === on) {
		message("Даты не могут быть равны", "Ошибка заполнения полей");
		return status.ignore;
	}
	return status.action;
}
